import Stripe from 'stripe';

export const getMetadataField = (
  price: { metadata: Stripe.Metadata; product: { metadata: Stripe.Metadata } },
  key: string
) => {
  if (price.metadata[key]) return price.metadata[key];
  return price.product.metadata[key];
};
